module.exports = __webpack_public_path__ + "img/Shiba-BG111.aa2f336e.jpg";